
<div class="actions-bar">

  <!-- <p class="text-small text-dark">Filtra: </p>
  <input id="destination-filter-input" [formControl]="destinationFilterFormControl" placeholder="Nome o numero di telefono"> -->

  <p class="text-small text-dark margin-left-30 margin-right-10"> 
      Dal:
  </p>
  <input id="from-datepicker-input" [matDatepicker]="fromDatepicker" [formControl]="fromFormControl"
    (dateChange)="fromDateChanged($event)">
  <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
  <mat-datepicker #fromDatepicker></mat-datepicker>

  <p class="text-small text-dark margin-left-20 margin-right-10"> 
      Al:
  </p>
  <input id="to-datepicker-input" [matDatepicker]="toDatepicker" [formControl]="toFormControl"
    (dateChange)="toDateChanged($event)">
  <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
  <mat-datepicker #toDatepicker></mat-datepicker>

  <p class="text-small text-error margin-top-10 margin-left-20" *ngIf="error" > 
    {{ errorMessage }}
  </p>

</div>

<div id="logsLayout">

  <table mat-table #accessLogsTable class="simple-table">

    <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>Stato</th>
        <td mat-cell *matCellDef="let element"> 
          <img class="log-state-img" src="assets/img/log/access_granted.png" *ngIf="element.isGranted()" />
          <img class="log-state-img" src="assets/img/log/access_denied.png" *ngIf="!element.isGranted()" />
        </td>
      </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef i18n="@@logs_user">Utente</th>
      <td mat-cell *matCellDef="let element"> 
        <span class="text-dark">{{element.user.username}}</span>
        <br/> 
        <span class="text-small">{{element.user.phoneNumber}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="accessName">
      <th mat-header-cell *matHeaderCellDef i18n="@@logs_access">Accesso</th>
      <td mat-cell *matCellDef="let element"> {{element.accessName}} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef i18n="@@logs_date">Data</th>
      <td mat-cell *matCellDef="let element"> 
        {{ element.getDateFriendly() }} <ng-container i18n="@@logs_at_hour"> alle ore </ng-container> {{ element.getTimeFriendly() }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" *ngIf="!isLoading"></mat-paginator>

  <app-loading-screen #accesslogloader></app-loading-screen>

</div>